import styled from 'styled-components';

const SearchConditionStyled = styled.div`
  .card-content-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: ${(props) => props.theme.spacing(3)}
      ${(props) => props.theme.spacing(4)};
    .left {
      display: flex;
      flex-direction: row;
      flex-grow: 1;
      gap: 48px;
      .single-select {
        width: 100%;
        /* position: relative; */
      }
    }
    .clear-btn {
      position: absolute;
      /* bottom: 0; */
      right: 8px;
    }
    .button-group {
      height: 100%;
      margin-left: ${(props) => props.theme.spacing(104 / 8)};
      display: flex;
      /* flex-direction: column; */
      justify-content: space-between;
      align-items: center;
      gap: ${(props) => props.theme.spacing(3)};
      /* .reset {
        margin-right: 0;
      }
      .search {
        margin-right: 0;
      } */
    }
  }
`;

export default SearchConditionStyled;
